import {
  ApiResponse,
  EventTypeDownloadResponse,
  EventTypeUIResponse,
} from "../../models/ApiResponse";
import {
  AddEventTypeRequest,
  UpdateEventTypeRequest,
} from "../../models/requestModels/eventTypeRequest";
import { EventTypeResponse } from "../../models/responseModels/eventTypeResponse";
import { axiosRequests } from "../axiosRequest";

export const EventTypeAgent = {
  getEventTypeList: () =>
    axiosRequests.get<EventTypeUIResponse>("/eventType/GetEventTypeList"),
  eventTypeCsvDownload: (eventTypeData: EventTypeResponse[]) =>
    axiosRequests.post<EventTypeDownloadResponse>(
      "/eventType/DownloadCsv",
      eventTypeData
    ),
  eventTypeXlsxDownload: (eventTypeData: EventTypeResponse[]) =>
    axiosRequests.postXlsx<Blob>("/eventType/DownloadXlsx", eventTypeData),
  updateEventType: (eventTypeData: UpdateEventTypeRequest) =>
    axiosRequests.post<ApiResponse>(
      "/eventType/updateEventType",
      eventTypeData
    ),
  addEventType: (eventTypeData: AddEventTypeRequest) =>
    axiosRequests.post<ApiResponse>("/eventType/addEventType", eventTypeData),
};
